module.exports = __webpack_public_path__ + "img/5.8be2f4ca.jpg";